import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, TemplateRef, ViewChild, ViewChildren, ChangeDetectionStrategy, inject } from '@angular/core';
import {
  ActionIconDef, Grid as InavistaGrid, GridActionIconClickEvent, GridConfig, GridRowCommitEvent, GridRowEditStartEvent,
  GridRowsSelectedEvent, GridToolbarActionClickEvent,
} from '@inavista/components/grid';
import { CommonService} from 'projects/service/src/app/shared/services/common.service';
import { exportInavistaGrid } from 'projects/service/src/app/shared/utils/inavista-grid-export';
import { LocalRowsGridApi, provideLocalGridRows } from 'projects/service/src/app/shared/utils/local-rows-grid-api';
import { CellEdit, DropdownEditor, NumberEditor, TextEditor } from 'projects/service/src/app/shared/utils/cell-editors';
import { coreInventoryRetrunOrderStatuses, returnOrderStatuses } from '../../../models/orders.model';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiResponse, UserRoles } from 'projects/service/src/app/shared/models/app.model';
import { InventoryService } from '../../../services/inventory.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ServiceOrderService} from 'projects/service/src/app/modules/service-order/services/service-order.service';
import {
  ADD_ITEM_ACTION, buildCoreReturnItemsGridConfig, CORE_RETURN_CORE_ITEMS_PERSISTENCE_KEY, coreReturnItemsActionIcons,
  coreReturnItemsSchema, DELETE_ITEM_ACTION, OPEN_FIELD,
} from '../core-return-order-items.grid.config';

// The old grid's content was (popup body height - 370) tall, with its toolbar and header above it.
// The inavista grid draws them inside its own box.
const GRID_CHROME_PX = 92;

@Component({
    selector: 'app-core-return-order-popup-core-items-tab',
    templateUrl: './core-return-order-popup-core-items-tab.component.html',
    styleUrls: ['./core-return-order-popup-core-items-tab.component.scss'],
    // The grid reads this.items, not an endpoint.
    providers: [...provideLocalGridRows()],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CoreReturnOrderPopupCoreItemsTabComponent implements OnChanges, OnInit, AfterViewInit {

  @ViewChild('returnOrderItemsGrid') returnOrderItemsGrid: InavistaGrid;
  @ViewChildren('cellEditor') cellEditorTemplates: QueryList<TemplateRef<unknown>>;
  @ViewChild('itemCell', { static: true }) itemCell: TemplateRef<unknown>;

  @Input() items = [];
  @Input() category: any;
  @Input() warehouse: any;
  @Input() inventoryItems: any;
  @Input() reasonsDDL: any;
  @Input() status: any;

  @Output() toggleGenerateStatementButton = new EventEmitter();

  itemsList: any;

  gridConfig: GridConfig = null;
  actionIcons: ActionIconDef[] = [];
  validationApplied: boolean = false;
  // reasonValidationFail: boolean = false;
  skipBeginEditEvent: boolean = false;

  itemsObject: DropdownEditor;

  itemDescriptionObject: TextEditor;

  itemGroup: any;

  itemQuantityObject: NumberEditor;

  selectedRowId: string;
  showItemAdvancedSearchPopup: boolean = false;

  onItemUpdate = new Subject<string>();
  reasonDescription: any;

  USER;
  isManager: boolean = false;
  isCSA: boolean = false;
  gridHeight: number;
  showLoader: boolean = false;
  isReadOnly: boolean = false;
  serviceOrderId: string;
  showServiceOrderPopup: boolean = false;
  serviceOrderData: any;
  defectiveOnHand: any = 0;
  itemOnhandQuantityObject: TextEditor;
  itemCommentObject: TextEditor;
  serviceOrderIdLN: any;
  itemServiceOrderObject: TextEditor;
  itemCode: any;
  comment: string = '';
  itemServiceOrderLNObject: TextEditor;
  allowEditing = false;

  // The grid's columns in the old order, their editors (CellEditorHost), and the editors open in the row being edited.
  readonly editFields = ['itemSOKey', 'serviceOrderId', 'serviceOrderIdLN', 'itemDescription', 'defectiveOnHand', 'quantity', 'comments'];
  readonly edits: Record<string, CellEdit> = {
    itemSOKey: this.initItemsDDL(),
    serviceOrderId: this.initItemServiceOrder(),
    serviceOrderIdLN: this.initItemServiceOrderLN(),
    itemDescription: this.initItemDescription(),
    defectiveOnHand: this.initItemOnHnad(),
    quantity: this.initItemQuantity(),
    comments: this.initItemComment(),
  };
  readonly openEditors = new Map<string, CellEdit>();
  // The row open in the grid (the old grid.isEdit), the open row's hidden columns, the ticked rows.
  isEditing = false;
  hiddenEditRow: any = null;
  hiddenEditFields: string[] = [];
  private checkedItems: any[] = [];
  private readonly gridRows = inject(LocalRowsGridApi);

  constructor(
    private commonService: CommonService,
    private inventoryService: InventoryService,
    private serviceOrderService: ServiceOrderService,
  ) {
    this.isCSA = this.commonService.USER.role === UserRoles.csa;
    this.isManager = this.commonService.USER.role === UserRoles.manager;
    this.isReadOnly = this.commonService.USER.role === UserRoles.readOnly;
  }

  ngOnChanges(change: SimpleChanges) {
    this.refreshRows();
    this.toggleButtonDisable();

    // The order left Open: no more Delete (the old grid hid its Actions column).
    if(change && change.status && change.status.currentValue && change.status.previousValue === coreInventoryRetrunOrderStatuses.open){
        this.actionIcons = [];
    }
  }

  ngOnInit(): void {
    this.gridHeight = document.getElementById('core-return-order-popup-body').clientHeight - 370 + GRID_CHROME_PX;
    this.warehouse = this.commonService.USER.role === UserRoles.fst ? this.commonService.USER.warehouse : this.warehouse;
    this.allowEditing = this.status === returnOrderStatuses.open && !this.isCSA && !this.isManager && !this.isReadOnly;
    // this.allowEditing = this.status === returnOrderStatuses.open && this.commonService.roleClaims['Inv_ServiceableTabGrid_Toolbar_Return_Order']?.visible;
    this.setItemsData();
    this.getItemList();
    this.onItemUpdate
    .pipe(
        debounceTime(500),
        distinctUntilChanged()
    ).subscribe(value => {
        if (this.itemsObject) {
            this.itemsObject.showPopup();
            this.itemsObject.showSpinner();
            this.getItemList();
        }
    });
  }

  // The editor templates are drawn: the grid is configured with them.
  ngAfterViewInit(): void {
    setTimeout(() => {
      const templates = this.cellEditorTemplates.toArray();
      const isOpen = this.status === coreInventoryRetrunOrderStatuses.open;
      this.gridRows.columns.set(LocalRowsGridApi.schema(coreReturnItemsSchema(this.editFields)));
      this.gridConfig = buildCoreReturnItemsGridConfig({
        persistenceKey: CORE_RETURN_CORE_ITEMS_PERSISTENCE_KEY,
        fields: this.editFields,
        backing: ['serviceOrderId'],
        editors: Object.fromEntries(this.editFields.map((field, i) => [field, templates[i]])),
        cellTemplates: { itemSOKey: this.itemCell },
        selectable: !isOpen,
        canAdd: isOpen,
        canExport: !!this.commonService.roleClaims['AllGrid_Toolbar_Excel_Export']?.visible,
        // The old editSettings.allowEditing: Open, and not a CSA, manager or read-only user.
        editLockReason: () => this.allowEditing ? null : 'Items can be changed while the return order is Open.',
      });
      this.actionIcons = isOpen ? coreReturnItemsActionIcons() : [];
      this.refreshRows();
      this.toggleButtonDisable();
    });
  }

  // The rows the grid shows: the items not deleted (the old Query isDeleted equal false).
  refreshRows() {
    if (!this.gridConfig) return;
    this.gridRows.rows.set((this.items ?? []).filter(item => item.isDeleted === false).map(item => ({ ...item })));
    this.returnOrderItemsGrid?.refresh();
  }

  /** The page's own item a grid row stands for. */
  itemFor(row: any) {
    return (this.items ?? []).find(item => item.tempRowId === row?.tempRowId) ?? row;
  }

  getItemList(searchString: string = null) {
    // this.inventoryService.popupLoader.next(true);
    const category = this.category?.toLowerCase();
    this.inventoryService.getInventoryForDDL(category, this.warehouse)
    .subscribe((res: ApiResponse) => {
        if (res && res.result && res.result.length) {
          this.itemsList = res.result.filter(x => !x.isDeleted);
          this.itemsList.map( (item) => {
            item.itemSOKey = `${item.item}-${item.serviceOrderId}`;
            item.value = item.itemSOKey;
            item.text = `${item.itemSOKey} | ${item.description}`;
          })

          const existingItems = [];
          (this.items as any).forEach(item => {
            if (item.itemSOKey && !item.isDeleted && item.itemSOKey !== searchString) {
                existingItems.push(item.itemSOKey);
            }
          });

          this.itemsList = this.itemsList.filter(item => {
            item.itemSOKey = `${item.item}-${item.serviceOrderIdLN?item.serviceOrderIdLN:item.serviceOrderId}`;
            item.value = item.itemSOKey;
            item.text = `${item.itemSOKey} | ${item.description}`;
            this.inventoryService.popupLoader.next(false);
            if (existingItems.length) {
              return !existingItems.includes(item.itemSOKey)
            } else {
              return true;
            }

          });

          if (this.itemsObject) {
            this.itemsObject.dataSource = this.itemsList;
            this.itemsObject.hideSpinner();
          }
          this.inventoryService.popupLoader.next(false);
        } else {
          this.itemsList = [];
          if (this.itemsObject) {
              this.itemsObject.hideSpinner();
              this.itemsObject.dataSource = [];
          }
          this.inventoryService.popupLoader.next(false);
        }
    });
  }

  // The row opened: the old actionBegin('beginEdit'), then its editors draw.
  onRowEditStart(event: GridRowEditStartEvent) {
    const rowData = this.itemFor(event.row);
    if (!rowData) return;
    this.isEditing = true;
    this.inventoryService.popupLoader.next(true);
    if ( rowData.itemSOKey ) {
        if ( this.skipBeginEditEvent ) {
            this.skipBeginEditEvent = false;
        } else {
            this.getItemList(rowData.itemSOKey);
        }
    }
    else{
      this.getItemList();
    }
    const shown = this.returnOrderItemsGrid?.visibleColumnIds() ?? this.editFields;
    this.hiddenEditFields = this.editFields.filter(f => !shown.includes(f));
    this.hiddenEditRow = this.hiddenEditFields.length ? rowData : null;
    // Leaving the row always saves it, as the Syncfusion grid did: the row counts as changed from the start.
    const marked = this.returnOrderItemsGrid?.setDraftValue(OPEN_FIELD, String(Date.now()));
    if (!marked) setTimeout(() => this.returnOrderItemsGrid?.setDraftValue(OPEN_FIELD, String(Date.now())));
  }

  onRowsSelected(event: GridRowsSelectedEvent) {
    this.checkedItems = event.rows.map(row => this.itemFor(row));
    this.status !== coreInventoryRetrunOrderStatuses.open && this.toggleGenerateStatementButton.emit(this.checkedItems)
  }

  // Enter, the ✓ icon or a click on another row: every editor's value goes into the row, as the Syncfusion grid did,
  // then the old actionComplete('save').
  onRowCommit(commit: GridRowCommitEvent) {
    const edited = this.itemFor(commit.row);
    if (!edited) return;
    for (const [field, edit] of this.openEditors) edited[field] = edit.read();
    this.isEditing = false;
    this.hiddenEditRow = null;
    this.toggleButtonDisable();
    let rowData : any = {};
    if(this.itemsObject.value && this.itemsObject.value !== commit.original?.['itemSOKey'] && (this.items as any).find(item => item.id && item.itemSOKey === this.itemsObject.value)){
      rowData = (this.items as any).find(item => item.itemSOKey === this.itemsObject.value && item.isDeleted);
      rowData.isDeleted = false;
      this.setRowData(rowData)
    } else {
      rowData = (this.items as any).find(item => item.lineNumber === edited.lineNumber);
      this.setRowData(rowData)
    }
    this.refreshRows();
  }

  // Esc or ✕: the row stays as it was (Syncfusion's cancel).
  onRowRevert() {
    this.isEditing = false;
    this.hiddenEditRow = null;
  }

  setItemsData() {
    this.items?.map((item, index) => {
        return this.setItemsRow(item, index);
    });
    if (this.status === coreInventoryRetrunOrderStatuses.open) {
      this.addEmptyRowsToItemsData();
    }
  }

  addEmptyRowsToItemsData() {
    for (let i = 0; i < 2; i++) {
      this.items.push(this.setItemsRow({}, this.getMaxRowId(this.items)));
    }
  }

  onServiceOrderClick(serviceOrderId: string) {
    if (!serviceOrderId) return;
    this.serviceOrderId = serviceOrderId;
    this.inventoryService.popupLoader.next(true);
    this.serviceOrderService.getServiceOrderById(serviceOrderId)
      .subscribe((res: any) => {
        this.serviceOrderId = serviceOrderId;
        this.serviceOrderData = res.result;
        this.inventoryService.popupLoader.next(false);
        this.showServiceOrderPopup = true;
      }, (error: HttpErrorResponse) => {
        this.inventoryService.popupLoader.next(false);
      });
  }

  // Add Item: refused while a row is open, as before; otherwise rows are added until two are empty.
  onToolbarActionClick(event: GridToolbarActionClickEvent) {
    if (event.key !== ADD_ITEM_ACTION) return;
    if (this.isEditing) {
      this.commonService.showNotification('warning', 'Item is in edit mode!');
      return;
    }
    this.inventoryService.popupLoader.next(true);
    this.checkEmptyRow();
    this.inventoryService.popupLoader.next(false);
  }

  // The old Excel export: the rows the grid shows, the visible columns, "Return Orders Items(<date>).xlsx".
  onExportRequested() {
    if (this.isEditing) {
      this.commonService.showNotification('warning', 'Item is in edit mode!');
      return;
    }
    exportInavistaGrid(this.returnOrderItemsGrid, 'Return Orders Items');
  }

  onActionIconClick(event: GridActionIconClickEvent) {
    if (event.iconKey !== DELETE_ITEM_ACTION) return;
    const rowData = this.itemFor(event.row);
    if (rowData.id && rowData.itemCode) {
        this.commonService.showConfirmation('Are you sure? You want to delete this item?').then(result => {
            if (result.isConfirmed) {
                rowData.isDeleted = true;
                this.checkEmptyRow();
                this.toggleButtonDisable();
                this.refreshRows();
            }
        })
    } else {
        const index = (this.items as any).findIndex(x => x.tempRowId === rowData.tempRowId);
        (this.items as any).splice(index, 1);
        this.toggleButtonDisable();
        this.checkEmptyRow();
        this.refreshRows();
    }
  }

  checkEmptyRow(){
    if(this.items.filter(x => !x.itemCode && !x.isDeleted).length < 2){
        this.addItem();
    }
  }

  toggleButtonDisable() {
      // if(this.status !== coreInventoryRetrunOrderStatuses.open){
          const elem: any = document.getElementById('core-return-order-btn');
          if(this.status !== coreInventoryRetrunOrderStatuses.open){
              elem.disabled = this.status !== coreInventoryRetrunOrderStatuses.open;
          } else {
              if ((this.items as any)?.filter(item => item.itemCode && !item.isDeleted).length) {
                  elem.disabled = false;
              } else {
                  elem.disabled = true;
              }
          }
      // }
  }

  addItem() {
    let newRow = this.setItemsRow({}, this.getMaxRowId(this.items));
    (this.items as any).push(newRow);
    if((this.items as any).filter(x => !x.itemCode && !x.isDeleted).length < 2){
      this.addItem();
    } else {
      this.refreshRows();
    }
  }

  setItemsRow(item, index) {
    item.id = item.id || 0,
    item.tempRowId = index + 1;
    item.lineNumber = index + 1;
    item.itemCode = item.itemCode;
    item.itemDescription = item.itemDescription || item.description || '';
    item.itemGroup = item.itemGroup || '';
    item.serviceItemGroup = item.serviceItemGroup || '';
    item.defectiveOnHand = item.defectiveOnHand ?? null;
    item.quantity = item.quantity ?? null;
    item.reasonCode = item.reasonCode || this.reasonsDDL[0].value;
    item.reasonDescription  = item.reasonDescription  || this.reasonsDDL[0].description;
    item.createdBy = item.createdBy || '';
    item.createdByName = item.createdByName || null;
    item.lastUpdatedBy = item.lastUpdatedBy || '';
    item.lastUpdatedByName = item.lastUpdatedByName || '';
    item.isDeleted = item.isDeleted || false;
    item.serviceOrderIdLN = item.serviceOrderIdLN || '';
    item.serviceOrderId = item.serviceOrderId || item.serviceOrderIdLN || '';
    return item;
  }

  setRowData(rowData){
    rowData.itemCode = this.itemCode;
    rowData.itemSOKey = this.itemsObject.value;
    // rowData.itemDescription = this.itemDescriptionObject.value;
    rowData.itemGroup = this.itemGroup;
    rowData.serviceOrderIdLN = this.itemServiceOrderLNObject.value;
    rowData.serviceOrderId = this.serviceOrderId || this.serviceOrderIdLN;
    rowData.reasonDescription = this.reasonDescription;
    const emptyRecordsList = (this.items as any).filter((item, index) => {
      if (!item.itemSOKey) {
        item.rowIndex = index;
        return true;
      }
    });

    this.checkEmptyRow();
  }

  getMaxRowId(datasource) {
    if (datasource.length) {
      return Math.max.apply(Math, datasource.map(row => row.tempRowId) || 0);
    } else {
      return 0;
    }
  }

  // The open row is saved first, as the old endEdit (the Syncfusion grid's own save).
  private endEdit() {
    this.returnOrderItemsGrid?.saveBatch();
  }

  getData() {
    this.endEdit();
    return {
        itemList: (this.items as any)
            .filter(x => x.itemCode)
            .map(item => {
                item.serviceOrderId = item.serviceOrderId || item.serviceOrderIdLN;
                return item;
            })
    }
  }

  getSelectedData(){
      this.endEdit();
      return {
          itemList: (this.checkedItems as any)
              .filter(x => x.itemCode)
              .map(item => {
                  item.serviceOrderId = item.serviceOrderId || item.serviceOrderIdLN;
                  return item;
              })
      }
  }

  validateForSave() {
    this.endEdit();
    const itemsRows = (this.items as any).filter(item => item.itemCode && !item.isDeleted);

    if (itemsRows.length) {
      for (const item of itemsRows) {
        if (!this.validateQuantityAndComments(item)) {
          return false;
        }
      }
    }

    return true;
  }

  validateQuantityAndComments(item) {
    if (item.quantity === null) {
      this.commonService.showNotification('error', `Quantity is missing for <br> ${item.itemSOKey} - ${item.itemDescription}`, 'center', 5000);
      return false;
    } else if (item.defectiveOnHand !== item.quantity && !item.comments) {
      this.commonService.showNotification('error', `Please add a reason for the difference in quantity of <br> ${item.itemSOKey} - ${item.itemDescription}`, 'center', 5000);
      return false;
    }
    return true;
  }

  validateForGenerateStatment() {
    this.endEdit();
    const itemsRows = (this.items as any).filter(item => item.itemCode && !item.isDeleted);

    if (itemsRows.length) {
      for (const item of itemsRows) {
        if (!this.validateQuantityAndComments(item)) {
          return false;
        }
      }
    } else {
        this.commonService.showNotification('error', 'Atleast one item needed in an Order to generate return order statement!');
        return true;
    }

    return true;
  }

  // The search is never opened from this tab (its icon is not added); the item picked goes into the open row.
  onItemAdvancedSearchPopupClose(data: any) {
    this.showItemAdvancedSearchPopup = false;
    if (!data || !this.itemsObject) return;
    this.itemsObject.value = data.item;
    this.itemsObject.dataSource = [{
      text: `${data.item} | ${data.itemDescription}`,
      value: data.item,
      ...data
    }];
  }

  initItemsDDL(): CellEdit {
    return {
        read: () => this.itemsObject?.value,
        destroy: () => this.itemsObject?.destroy(),
        open: args => {
            this.selectedRowId = args.rowData?.rowId;
            this.itemCode = args.rowData.itemCode;
            return this.itemsObject = new DropdownEditor({
                dataSource: this.itemsList,
                fields: { value: 'value', text: 'text' },
                value: args.rowData.itemSOKey,
                allowFiltering: true,
                popupWidth: '450px',
                openOnFocus: true,
                // Typing filters the shown list (Contains) and reloads it, as the Syncfusion list did (itemSOKey was
                // never on the filtering event: the reload has always been the unfiltered list).
                filterLocally: true,
                filtering: args => { this.onItemUpdate.next((args as any).itemSOKey); },
                change: (event: any) => {
                    if ( event.value && event.itemData ) {
                        this.itemCode = event.itemData.item;
                        this.itemDescriptionObject.value = event.itemData.description;
                        this.itemGroup = event.itemData.itemGroup;
                        this.serviceOrderIdLN = event.itemData.serviceOrderIdLN;
                        this.itemServiceOrderLNObject.value = event.itemData.serviceOrderIdLN;
                        this.serviceOrderId = event.itemData.serviceOrderId || event.itemData.serviceOrderIdLN;
                        if(this.itemServiceOrderObject){
                            this.itemServiceOrderObject.value = this.serviceOrderId;
                        }
                        this.itemOnhandQuantityObject.value = event.itemData.isDefective;
                        this.itemQuantityObject.value = this.itemQuantityObject.value ?? this.itemOnhandQuantityObject.value;
                    }
                }
            });
        }
    }
  }

  initItemServiceOrder(): CellEdit {
    return {
        read: () => this.itemServiceOrderObject?.value,
        destroy: () => this.itemServiceOrderObject?.destroy(),
        open: args => {
            this.serviceOrderId = args.rowData.serviceOrderId || args.rowData.serviceOrderIdLN;
            return this.itemServiceOrderObject = new TextEditor({
                value: this.serviceOrderId,
                enabled: false
            });
        }
    }
  }

  initItemServiceOrderLN(): CellEdit {
    return {
        read: () => this.itemServiceOrderLNObject?.value,
        destroy: () => this.itemServiceOrderLNObject?.destroy(),
        open: args => {
            return this.itemServiceOrderLNObject = new TextEditor({
                value: args.rowData.serviceOrderIdLN,
                enabled: false
            });
        }
    }
  }

  initItemDescription(): CellEdit {
    return {
        read: () => this.itemDescriptionObject?.value,
        destroy: () => this.itemDescriptionObject?.destroy(),
        open: args => {
            return this.itemDescriptionObject = new TextEditor({
                value: args.rowData.itemDescription,
                enabled: false
            });
        }
    }
  }

  initItemOnHnad(): CellEdit {
    return {
        read: () => this.itemOnhandQuantityObject?.value,
        destroy: () => this.itemOnhandQuantityObject?.destroy(),
        open: args => {
            return this.itemOnhandQuantityObject = new TextEditor({
                value: args.rowData.defectiveOnHand,
                enabled: false,
            });
        }
    }
  }

  initItemQuantity(): CellEdit {
    return {
        read: () => this.itemQuantityObject?.value,
        destroy: () => this.itemQuantityObject?.destroy(),
        open: args => {
            return this.itemQuantityObject = new NumberEditor({
                value: args.rowData.quantity,
                min: 0,
                max: args.rowData.defectiveOnHand,
                format: 'n',
                step: 1,
                decimals: 0,
            });
        }
    }
  }

  initItemComment(): CellEdit {
    return {
        read: () => this.itemCommentObject?.value,
        destroy: () => this.itemCommentObject?.destroy(),
        open: args => {
            this.comment = args.rowData.comments;
            return this.itemCommentObject = new TextEditor({
                value: args.rowData.comments,
                change: (event: any) => {
                    this.comment = event.value;
                }
            });
        }
    }
  }
}
